import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3725835f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3725835f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3725835f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3725835f')) {
      api.createRecord('3725835f', component.options)
    } else {
      api.reload('3725835f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3725835f&scoped=true", function () {
      api.rerender('3725835f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/monitor/redis/index.vue"
export default component.exports